module.exports = __webpack_public_path__ + "img/mental5.954fbe1a.png";